module.exports = __webpack_public_path__ + "img/ast01.3c853295.svg";